import { FilterPathSeparatorEnum, FilterPathOperatorEnum } from "../../types/filterPath.js";
import { getFilterNestedField } from "./getFilterNestedField.js";
const splitCompositeFilterField = (compositeField) => {
  const filterSeparatorSymbolIndex = compositeField.indexOf(FilterPathSeparatorEnum.Operator);
  if (filterSeparatorSymbolIndex === -1) {
    return {
      key: compositeField
    };
  }
  const filterKey = compositeField.substring(0, filterSeparatorSymbolIndex);
  const compositeOperator = compositeField.substring(filterSeparatorSymbolIndex + 1);
  if (compositeOperator.startsWith(FilterPathOperatorEnum.Min)) {
    return {
      key: filterKey,
      operator: FilterPathOperatorEnum.Min
    };
  }
  if (compositeOperator.startsWith(FilterPathOperatorEnum.Max)) {
    return {
      key: filterKey,
      operator: FilterPathOperatorEnum.Max
    };
  }
  if (compositeOperator.startsWith(FilterPathOperatorEnum.NestedField)) {
    return {
      key: filterKey,
      operator: FilterPathOperatorEnum.NestedField,
      field: getFilterNestedField(compositeOperator)
    };
  }
  return {
    key: filterKey
  };
};
export {
  splitCompositeFilterField
};
